export const SUPPORTED_LOCALES = ['fr', 'en', 'de'] as const;
export const DEFAULT_LOCALE = 'fr' as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];
